import FilterInputItem from '../../shared/Filter/FilterInputItems';

export const listQueryFilterParams = () =>
  listSearchModalParams.reduce((acm, cur) => [...acm, cur.name], []);

export const listSearchModalParams = [
  FilterInputItem.email_externalid,
  FilterInputItem.payment_status_paid
];
